import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/HomePage.vue'),
    },
    {
      path: '/products',
      name: 'products',
      component: () => import('./views/ProductsPage.vue'),
    },
  ],
})
